import { PointsToCashForMortgageLayout } from './layout'
import { PointsToCashForMortgageRoutes } from './routes'

export const PointsToCashForMortgageNavigation = {
  Layout: PointsToCashForMortgageLayout,
  Routes: PointsToCashForMortgageRoutes,
}
